import { useTranslation } from 'react-i18next';
import { CHART_SOURCES, REFERENCE_SOURCES, chartReferenceKey, TSB_ZONES, TSB_RACE_RANGE } from './chartReferences';

export function ChartReferenceGuide({ type, setting }: { type: string; setting?: Record<string, unknown> }) {
  const { t } = useTranslation();
  const key = chartReferenceKey(type, setting);
  return <section className="chart-reference-guide">
    <h3>{t('chartReference.title')}</h3>
    <p>{t(`chartReference.examples.${key}`)}</p>
    {key === 'pmc' && <>
      <h3>{t('charts.pmcSplit.ranges')}</h3>
      <p>{t('charts.pmcSplit.guidance')}</p>
      <ul className="chart-reference-guide__zones">
      {TSB_ZONES.map(zone => <li key={zone.key}>
        <bdi dir="ltr" style={{ color: zone.color }}>{zone.range}</bdi>
        <span>{t(`chartReference.tsb.${zone.key}`)}</span>
      </li>)}
      </ul>
    </>}
    {key === 'pmc' && <>
      <h3>{t('chartReference.tsb.race')}</h3>
      <bdi dir="ltr" style={{ color: TSB_RACE_RANGE.color }}>TSB {TSB_RACE_RANGE.range}</bdi>
      <p>{t('chartReference.tsb.raceContext')}</p>
    </>}
    {type === 'power_profile' && <>
      <h3>{t('charts.powerProfile.reference.title')}</h3>
      <p>{t('charts.powerProfile.reference.note')}</p>
      <a href="https://www.trainingpeaks.com/blog/power-profiling/" target="_blank" rel="noopener noreferrer">TrainingPeaks · Andrew Coggan ↗</a>
    </>}
    <p className="chart-reference-guide__context">{t('chartReference.context')}</p>
    {(REFERENCE_SOURCES[key] ?? []).map(id => <a key={id} href={CHART_SOURCES[id].url} target="_blank" rel="noopener noreferrer">{CHART_SOURCES[id].title} ↗</a>)}
  </section>;
}
